export default __webpack_public_path__ + "static/eco-alliance-plant-73aca65362dc7b4f8bee4d7251c81ee4.svg";